import { STUDENT_DATA } from './student';

export const API = {
    ...STUDENT_DATA,
};
